import React, { useEffect, useRef, useState } from "react";
import s from "./ReadyForPayment.module.scss";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  PullRequestOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  addMessage,
  changeStatus,
  getApplicationDetails,
} from "../../redux/ApplicationSlice";
import { Button, notification, Tag } from "antd";
import {
  createPaymentOrder,
  getPartnerBalance,
  getPaymentLink,
} from "../../redux/BillingSlice";
import { getStatusTag } from "../../utils/functions";
import Footer from "../../components/Footer/Footer";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoginHeader from "../../components/Header/LoginHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";

var FileSaver = require("file-saver");

const ReadyForPaymentLink = () => {
  const dispatch: AppDispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const { width } = useWindowDimensions();

  const exchangeRate = useSelector(
    (state: RootState) => state.billing.exchangeRate?.usd_to_gel
  );
  const { t } = useTranslation();
  const application = useSelector(
    (state: RootState) => state.billing.payment_link
  );

  const user = useSelector((state: RootState) => state.user.user);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [timer, setTimer] = useState<any>(null);
  const buttonsBlockRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();
  const params = useParams();
  const queryParams = new URLSearchParams(location.search);
  const paymentFailStatus = queryParams.get("status") ? true : false;

  useEffect(() => {
    params.id && dispatch(getPaymentLink(params.id));
  }, [params.id]);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      buttonsBlockRef.current &&
      !buttonsBlockRef.current.contains(event.target as Node)
    ) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;
        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  // const payForApplication = async (values: any) => {
  //   const data = new FormData();
  //   data.append("status", "payment_confirmed");

  //   const res = await dispatch(
  //     changeStatus({ id: Number(application?.application.id), formData: data })
  //   );

  //   if (res.type === "applications/changeStatus/fulfilled") {
  //     await dispatch(
  //       getApplicationDetails(Number(application?.application.id))
  //     );
  //     await dispatch(getPartnerBalance());
  //     openNotification(true, "Вы подтвердили оплату!", "success")();

  //     await dispatch(
  //       addMessage({
  //         application: Number(application?.application.id),
  //         content: `Оплата в сумме ${application?.application.price} $ произведена`,
  //         application_status: "payment_confirmed",
  //       })
  //     );
  //   }

  //   if (
  //     res.type === "applications/changeStatus/rejected" &&
  //     res.payload &&
  //     "error" in res.payload
  //   ) {
  //     openNotification(true, res.payload.error, "error")();
  //   }
  // };

  const openFileInNewWindow = async (e: React.MouseEvent, file: any) => {
    e.preventDefault();

    if (file) {
      const fileExtension = file.split(".").pop()?.toLowerCase();
      if (fileExtension === "docx" || fileExtension === "xlsx") {
        await downloadFile(file);
      } else {
        window.open(file, "_blank");
      }
    }
  };
  const downloadFile = async (file: any) => {
    if (!file) return;
    try {
      const response = await fetch(file);
      if (!response.ok) throw new Error("Failed to fetch the file");
      const fileBlob = await response.blob();
      const mimeType = file.type || getMimeTypeByExtension(file);
      FileSaver.saveAs(fileBlob, "Квитанция");
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const getMimeTypeByExtension = (filename: string) => {
    const extension = filename.split(".").pop()?.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      pdf: "application/pdf",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      doc: "application/msword",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      jpeg: "image/jpeg",
      jpg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      txt: "text/plain",
      csv: "text/csv",
      zip: "application/zip",
    };
  };

  const createOrder = async (method: string) => {
    const res = await dispatch(
      createPaymentOrder({
        amount: Number(application?.application?.price),
        application_number: application?.application.application_number,
        payment_method: method,
      })
    ).unwrap();

    if (res?.payment_url) {
      window.location.href = res.payment_url;
    }
  };

  return (
    <div>
      {contextHolder}
      {width > 985 ? <LoginHeader /> : <MobileLoginHeader />}
      <div className={s.readyForPayment}>
        <div className={s.content}>
          <div className={s.main_title}>
            <PullRequestOutlined style={{ marginRight: "5px" }} />
            TRANSIT
          </div>
          <div className={s.user_info}>
            <div className={s.user_info_title}>{t("Реквизиты платежа")}</div>
            <div className={s.user_info_item}>
              <div className={s.item_label}>{t("ФИО")}:</div>
              <div className={s.item_value}>
                {application?.application?.user}
              </div>
            </div>
            <div className={s.user_info_item}>
              <div className={s.item_label}>{t("№ заявки")}:</div>
              <div className={s.item_value}>
                <div className={s.font}>
                  {application?.application.application_number}
                </div>
              </div>
            </div>

            <div className={s.user_info_item}>
              <div className={s.item_label}>{t("Статус")}:</div>
              <div className={s.item_value} style={{ marginRight: "-7px" }}>
                {application?.application.status &&
                  getStatusTag(application?.application.status, "sm", t)}
              </div>
            </div>
            <div className={s.user_info_item}>
              <div className={s.item_label}>{t("Курс на сегодня")}:</div>
              <div className={s.item_value}>
                <div className={s.font}> 1 USD = {exchangeRate} GEL</div>
              </div>
            </div>

            <div className={s.notification}>
              {t(
                "Оплата производится в ₾ по курсу Национального банка Грузии на день проведения операции"
              )}
            </div>
          </div>

          <div className={s.check}>
            <div className={s.check_item}>
              <div className={s.title}>
                {application?.application.status === "ready_to_payment" ? (
                  <div>
                    {paymentFailStatus && (
                      <Tag color="error" className={s.error_tag}>
                        <ExclamationCircleOutlined className={s.error_icon} />{" "}
                        {t("Отплата не прошла! Попробуйте еще раз")}.
                      </Tag>
                    )}
                    <div>{t("Cумма к оплате")}</div>
                  </div>
                ) : (
                  <div style={{ color: "green" }}>
                    <CheckCircleOutlined style={{ marginRight: "5px" }} />
                    {t("Оплата подтверждена")}
                  </div>
                )}
              </div>
              <div className={s.amount}>
                $ {application?.application?.price}
              </div>
            </div>
            <div className={s.btns_wrapper}>
              <Button
                disabled={
                  application?.application.status === "ready_to_payment"
                    ? false
                    : true
                }
                className={
                  application?.application.status === "ready_to_payment"
                    ? s.payment_btn
                    : s.payment_btn_disabled
                }
                style={{ width: user?.role === "driver" ? "60%" : "inherit" }}
                onClick={() => createOrder("bank_international")}
              >
                <img
                  src="/Visa-MasterCard-removebg-preview.png"
                  className={s.btn_logo}
                />
                {t("Оплатить международной картой")}
              </Button>
              <div style={{ position: "relative" }}>
                <Button
                  disabled={
                    application?.application.status === "ready_to_payment"
                      ? false
                      : true
                  }
                  className={
                    application?.application.status === "ready_to_payment"
                      ? s.payment_btn
                      : s.payment_btn_disabled
                  }
                  style={{ width: user?.role === "driver" ? "60%" : "inherit" }}
                  onMouseEnter={handleMouseEnter} // Показываем блок при наведении
                  //onMouseLeave={handleMouseLeave} // Скрываем блок при уходе
                >
                  <img src="/georgia.png" className={s.flag} />
                  {t("Оплатить картой банка Грузии")}
                </Button>
              </div>

              {isVisible && (
                <div
                  ref={buttonsBlockRef}
                  className={s.georgian_banks}
                  style={{
                    position: "absolute",
                    top: "330px",
                    width: "30%",
                    padding: "0px",
                    // background: "white",
                    marginLeft: "37px",
                    zIndex: 10,
                    transition: "opacity 0.2s ease-in-out",
                    opacity: isVisible ? 1 : 0,
                  }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <Button
                    disabled={
                      application?.application.status === "ready_to_payment"
                        ? false
                        : true
                    }
                    className={
                      application?.application.status === "ready_to_payment"
                        ? s.payment_btn
                        : s.payment_btn_disabled
                    }
                    style={{
                      width: user?.role === "driver" ? "60%" : "inherit",
                    }}
                    onClick={() => createOrder("bank_tbc")}
                  >
                    <img src="/TBC_Bank_logo.svg.png" className={s.bank_icon} />
                  </Button>
                  <Button
                    disabled={
                      application?.application.status === "ready_to_payment"
                        ? false
                        : true
                    }
                    className={
                      application?.application.status === "ready_to_payment"
                        ? s.payment_btn
                        : s.payment_btn_disabled
                    }
                    style={{
                      width: user?.role === "driver" ? "60%" : "inherit",
                    }}
                    onClick={() => createOrder("bank_boc")}
                  >
                    <img
                      src="/Bank of Georgia - Retail-Solid.png"
                      className={s.bank_icon2}
                    />
                  </Button>
                  <Button
                    disabled={
                      application?.application.status === "ready_to_payment"
                        ? false
                        : true
                    }
                    className={
                      application?.application.status === "ready_to_payment"
                        ? s.payment_btn
                        : s.payment_btn_disabled
                    }
                    style={{
                      width: user?.role === "driver" ? "60%" : "inherit",
                    }}
                    onClick={() => createOrder("bank_other")}
                  >
                    <img src="/georgia.png" className={s.flag} />
                    {t("Другие банки")}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ReadyForPaymentLink;
